import InfoTbs from '../info_tb/list';
export default {
    components: {
        InfoTbs
    },
    data() {
        return {
            tjs_info: {
                data: [],
            },
            show_tjs: false,
            tj_info: {
                data: [],
                r: {},
                admin: {}
            },
            show_tj: false,
            admins: [],
            show_tb: false,
            item_info: {},
            table: 'info',
            datas: {
                add: {
                    with_count: ['tbs'],
                    append: ['status_info', 'admin', 'bs_admin', 'zj_admin']
                }
            }
        };
    },
    computed: {
        disabled() {
            if (!this.r.id) {
                return false;
            }
            if (this.vuex_admin.admin_group_id == 1) {
                return false;
            }
            if (this.r.admin_id == this.vuex_admin.id) {
                if (this.r.status >= 2) {
                    return true;
                }
                return false;
            }
            return true;
        },
        show_check() {
            if (this.vuex_admin.admin_group_id == 1) {
                return true;
            }
            if (this.r.is_zj && this.vuex_admin.admin_group_id == 9) {
                return true;
            }
            if (!this.r.is_zj && this.vuex_admin.admin_group_id == 7) {
                return true;
            }
            return false;
        }
    },
    created() {

        this._load();
        this._admins([6, 8]);
    },
    methods: {
        _close_tb() {
            this.show_tb = false;
            this._load();
        },
        _sb(id) {
            this.$http.post('info/sb', {
                id
            }).then(res => {
                if (res.code) {
                    this._load();
                }
            })
        },
        _tc() {
            this.$http.post('info/tc', {
                admin_to: this.tjs_info.admin.id
            }).then(res => {
                if (res.code) {
                    this.show_tjs = false;
                }
            })
        },
        calculateGlobalIndex(index1, index) {
            let total = 0;
            // 累加所有先前外层循环元素的内层元素总数
            for (let i = 0; i < index1; i++) {
                total += this.tjs_info.data[i].tbs.length;
            }
            // 加上当前外层循环元素中，当前内层元素的局部序号
            return total + index + 1; // 如果你希望序号从1开始
        },
        _tjs(id, code) {
            this.$http.post('info/tjs', {
                id,
                code
            }).then(res => {
                if (res.code) {
                    this.tjs_info = res.data;
                    this.show_tjs = true;
                }
            })
        },
        _tj(id) {
            this.$http.post('info/tj', {
                id
            }).then(res => {
                if (res.code) {
                    this.tj_info = res.data;
                    this.show_tj = true;
                }
            })
        },
        _tb(item) {
            this.show_tb = true;
            this.item_info = { ...item };
        },
    },
};